import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import type { RootState } from '../../store/store';
import { decodeJwtPayload } from '../../utils/jwt';
import { resolverRotaInicial } from '../../shared/rota-inicial';

/**
 * Leva o usuário para a tela inicial dele (montado em `/` e no catch-all).
 *
 * at-81: a decisão saiu daqui e virou `resolverRotaInicial` — o mesmo resolvedor usado pelo
 * login e pelo callback do Google, que antes tinham cópias próprias e divergentes.
 */
const RedirectByRole: React.FC = () => {
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);
  const navigate = useNavigate();

  useEffect(() => {
    if (!accessToken || accessToken.trim() === '') return;

    const payload = decodeJwtPayload<{
      userType?: string;
      papeis?: string[];
      telaInicial?: string | null;
    }>(accessToken);

    navigate(resolverRotaInicial(payload), { replace: true });
  }, [accessToken, navigate]);

  return null;
};

export default RedirectByRole;
